'use client';

import type { FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import type {
  MarginProps,
  MaxWidthProps,
  PaddingProps,
} from '../../utils/spacing';
import { spacingStyle } from '../../utils/spacing';
import type { RevealProps } from '../Reveal/Reveal';
import { Reveal } from '../Reveal/Reveal';
import styles from './Paper.module.css';

export interface PaperProps
  extends RevealProps, MarginProps, PaddingProps, MaxWidthProps {
  variant?: 'outlined' | 'solid';
}

export const Paper: FC<PropsWithChildren<PaperProps>> = (props) => {
  const {
    children,
    className,
    activeOpacity = 1,
    inactiveOpacity = 1,
    variant = 'outlined',
  } = props;

  return (
    <div
      className={cx(styles.root, className)}
      data-variant={variant}
      style={spacingStyle({
        margin: props.margin,
        marginTop: props.marginTop,
        marginRight: props.marginRight,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        maxWidth: props.maxWidth,
      })}
    >
      <Reveal
        className={cx(
          styles.revealBorder,
          variant === 'solid' && styles.revealBorderSolid
        )}
        activeOpacity={activeOpacity}
        inactiveOpacity={inactiveOpacity}
      />

      <div
        className={styles.content}
        style={spacingStyle({
          padding: props.padding,
          paddingTop: props.paddingTop,
          paddingRight: props.paddingRight,
          paddingBottom: props.paddingBottom,
          paddingLeft: props.paddingLeft,
        })}
      >
        {children}
      </div>
    </div>
  );
};
